import React, {Component} from 'react';
import {Router, Route, Switch} from 'react-router';
import createHistory from 'history/createHashHistory';

import {Provider} from 'react-redux';
import { createStore,applyMiddleware } from 'redux';
import logger from 'redux-logger'
import rootReducer from './reducers';

import loginScreen from './container/con-login';
import registerScreen from './container/con-register';
import pageNotFindScreen from './container/con-401';
import homeScreen from './container/con-home';
import settingDealerScreen from './container/con-setting-dealer';
import settingAgentScreen from './container/con-setting-agent';
import settingCommissionScreen from './container/con-setting-commission';

import walletBalanceScreen from './container/con-wallet-balance';
import walletTopupScreen from './container/con-wallet-topup';

import dashboardTransactionScreen from './container/con-dashboard-transaction';
import saleAirtimeScreen from './container/con-sale-airtime';
import saleAirtimeBulkScreen from './container/con-sale-airtime-bulk';

import settingBundlesListScreen from './container/con-setting-bundles-list';
import settingBundlesCategoryScreen from './container/con-setting-bundles-category';
import settingBankingScreen from './container/con-setting-banking';

import reconHistory from "./component/recon/ReconHistoryPage";
import reconReport from "./component/recon/ReconReport";
import ConDashboardSummary from "./container/con-dashboard-summary";

const history = createHistory();
const store = createStore(
    rootReducer,
    applyMiddleware(logger)
);

class App extends Component {
    render() {
        return (
            <Provider store={store}>
            <Router history={history}>
                <Switch>

                    <Route exact path="/" component={loginScreen}/>
                    <Route path="/login" component={loginScreen}/>
                    <Route path="/register" component={registerScreen}/>
                    <Route path="/home" component={homeScreen}/>

                    <Route path="/setting-bundles-list" component={settingBundlesListScreen}/>
                    <Route path="/setting-bundles-category" component={settingBundlesCategoryScreen}/>
                    <Route path="/setting-dealer-banking" component={settingBankingScreen}/>

                    <Route path="/setting-dealer" component={settingDealerScreen}/>
                    <Route path="/setting-agent" component={settingAgentScreen}/>
                    <Route path="/setting-commission" component={settingCommissionScreen}/>
                    <Route path="/wallet-balance" component={walletBalanceScreen}/>
                    <Route path="/wallet-topup" component={walletTopupScreen}/>
                    <Route path="/dashboard-transaction" component={dashboardTransactionScreen}/>
                    <Route path="/dashboard-summary" component={ConDashboardSummary}/>

                    <Route path="/sale-airtime" component={saleAirtimeScreen}/>
                    <Route path="/sale-bulk" component={saleAirtimeBulkScreen}/>

                    <Route path={"/recon-history"} component={reconHistory}/>
                    <Route path={"/recon-report"} component={reconReport}/>


                    <Route component={pageNotFindScreen}/>
                </Switch>
            </Router>
            </Provider>

        );
    }
}

export default App;

/*
<div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.js</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
        </header>
 */
